export const config = {
    appname: 'cpffeed',
    client_id: '1764763107262737', // App ID
    facebook_app_id: '1764763107262737', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api_prefix: 'apicff',

    agency_id: '120634',
    bzbsUrl: 'https://apicff.buzzebees-uat.com',
    bzbsModuleUrl: 'https://cpfmodule.buzzebees-uat.com',
    bzbsWallet: 'https://apicflwallet.buzzebees-uat.com',
    bzbsModuleWallet: 'https://giftcardwalletmodule.buzzebees-uat.com',
    bzbsAddItemFromList: 'https://stg7.buzzebees.com/api/cart/',
    bzbsBlobUrl: 'https://cdn.buzzebees-uat.com/th',
    apiShoppingCartUrl: 'https://shoppingcartmodule35.buzzebees-uat.com',
    bzbsShoppingCartUrl: 'https://shoppingcartservice35.buzzebees-uat.com',
    bzbNewShoppingCartUrl: 'https://shoppingcartproduct.buzzebees-uat.com',
    bzbAddItem: 'https://stgc.buzzebees.com/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://stgc.buzzebees.com/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://stw.buzzebees.com',
    bzbsPointExpire: 'https://stw.buzzebees.com/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '2006048102-PoqEjAv3',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
    mainConfig: {
        home_product: 'campaign_cpffeed_product',
        menu_product: 'menu_cpffeed_product',
        privilege: 'campaign_cpffeed_privilege',
        menu_privilege: 'menu_cpffeed_privilege',
        marketplace: 'campaign_bzbs',
        menu_marketplace: 'menu_campaign_bzbs',
        news: 'campaign_cpffeed_news',
        main_dashboard: 'cpffeed_dashboard',
        passcode_category: ['9450005', '9450006', '9450007', '9450008', '9450009']
    },
    firebase: {
        apiKey: "AIzaSyAJlnp9bJcyNLZbIgPpTqBZRpVIqOKcSS8",
        authDomain: "cpf-feed-staging.firebaseapp.com",
        projectId: "cpf-feed-staging",
        storageBucket: "cpf-feed-staging.appspot.com",
        messagingSenderId: "263798742537",
        appId: "1:263798742537:web:10c10f4de9ebeb0abc22d8",
        measurementId: "G-6R60KKNSVK"
    }
};
